import shopIcon from 'src/assets/images/shopBanner/shopBannerIcon.webp';
import { Banner } from './type';

export const Banners: Banner[] = [
  {
    title: 'sidebarBanners.shop',
    text: 'sidebarBanners.shopDescription',
    backgroundImage: 'bg-SHOP_SIDEBAR_BANNER',
    icon: shopIcon,
    id: 'shop'
  }
];
